/* eslint-disable camelcase */
import ColumnDefinitionFactory from '@/app/shared/models/ColumnDefinitionFactory'

export default class AgGrid {
  constructor ({ col_definition, data, aggregation }) {
    this.columnDefs = col_definition.map((columnDef) => ColumnDefinitionFactory.create(columnDef))
    this.data = data
    this.aggregation = [{ ...aggregation, pivot: 'Total' }]
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/AgGrid.js